import jwtDecode from 'jwt-decode';
import fp from 'lodash/fp';
import queryString from 'query-string';
import React, { Component } from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { routes } from '../../constants';
import { userActions } from '../../state/modules/user';
import { LoadingButton } from '../components';

class ConfirmAcceptInvitation extends Component {

  constructor() {
    super();

    this.state = {
      businessName: null
    };
  }

  componentDidMount() {
    this.init(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.init(nextProps);
  }

  init(props) {
    const invitationToken = queryString.parse(this.props.location.search).invitationToken;

    // If we have invalid token provided, boot User to login page.
    try {
      const { businessName } = jwtDecode(invitationToken);

      this.setState({
        businessName: businessName
      });
    }
    catch (e) {
      this.props.goTo(routes.login);
    }
  }

  acceptInvitation() {
    const invitationToken = queryString.parse(this.props.location.search).invitationToken;
    const { businessId } = jwtDecode(invitationToken);
    this.props.acceptInvitation({ token: invitationToken, businessId: parseInt(businessId, 10) });
  }

  render() {
    const userEmail = fp.get('user.currentUser.email')(this.props)
    const isFetching = this.props.user.isFetching
    return (
      <div id='accept-invitation'>
        <Grid>
          <Row>
            <Col xs={12}>
              <h1 className="text-center">You have been invited {this.state.businessName ? `by ${this.state.businessName}` : ''} to join Caddie</h1>
              <p>Your <strong className='darker'>{userEmail}</strong> account will be transferred to <strong className='darker'>{this.state.businessName}</strong>.</p>
              <LoadingButton loading={isFetching} className='full large' onClick={() => this.acceptInvitation()} text={'Confirm & Accept Invitation'} />
            </Col>
            <Col xs={12}>
              <LinkContainer className='full large' exact to={routes.app.root}>
                <Button>Ignore</Button>
              </LinkContainer>
              {
                this.props.user.error ?
                  <div className='text-danger'>
                    {this.props.user.error ? this.props.user.error : 'Something went wrong while accepting the invitation, please try again.'}
                  </div>
                  : null
              }
            </Col>
            <Col xs={12}>
              <LinkContainer className='full large' exact to={{ pathname: routes.onboarding.invitationSignUp, search: this.props.location.search }}>
                <Button bsStyle='plain'>Sign up another account</Button>
              </LinkContainer>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
  acceptInvitation: bindActionCreators(userActions.user.acceptInvitation, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAcceptInvitation);



// WEBPACK FOOTER //
// ./src/containers/pages/confirm-accept-invitation.js